export const DEVTOOLS_MAIN_ICON = `
<svg viewBox="0 0 22 24" aria-hidden="true">
  <path
    d="M4.17 10.42L3.08 1.53C2.95.45 3.87-.46 4.94-.33l7.31.91 7.81-.74"
    transform="matrix(0.707107 0.707107 -0.707107 0.707107 8.37011 3.33333)"
    fill="none"
    stroke="currentColor"
    stroke-width="1.6"
    stroke-linejoin="bevel"
  />
  <path
    d="M0 2.5L3.3333333 0"
    transform="matrix(-4.37114e-08 -1 1 -4.37114e-08 15.0368 6.25)"
    fill="none"
    stroke="currentColor"
    stroke-width="0.6"
    stroke-miterlimit="10"
  />
  <path
    d="M0 2.5L3.3333333 0"
    transform="matrix(-4.37114e-08 -1 1 -4.37114e-08 17.5368 5)"
    fill="none"
    stroke="currentColor"
    stroke-width="0.6"
    stroke-miterlimit="10"
  />
</svg>`;

export const DEVTOOLS_GRID_ICON = `
<svg viewBox="0 0 20 20" aria-hidden="true">
  <path
    d="M6.4 0h3.2c2.24021 0 3.36031 0 4.21596.43597a4 4 0 0 1 1.74806 1.74807C16 3.03969 16 4.15979 16 6.4v3.2c0 2.24021 0 3.36031-.43598 4.21596a4 4 0 0 1-1.74806 1.74806C12.96031 16 11.84021 16 9.6 16H6.4c-2.24021 0-3.36031 0-4.21596-.43598a4 4 0 0 1-1.74807-1.74806C0 12.96031 0 11.84021 0 9.6V6.4c0-2.24021 0-3.36031.43597-4.21596A4 4 0 0 1 2.18404.43597C3.03969 0 4.15979 0 6.4 0Z"
    transform="translate(2 2)"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-miterlimit="10"
    fill-rule="evenodd"
  />
  <path d="M0.5 0L0.5 20" transform="translate(5.5 0)" fill="none" stroke="currentColor" stroke-width="1" stroke-dasharray="1 1" />
  <path d="M0.5 0L0.5 20" transform="translate(9.5 0)" fill="none" stroke="currentColor" stroke-width="1" stroke-dasharray="1 1" />
  <path d="M0.5 0L0.5 20" transform="translate(13.5 0)" fill="none" stroke="currentColor" stroke-width="1" stroke-dasharray="1 1" />
</svg>`;

export const DEVTOOLS_INVIEW_ICON = `
<svg viewBox="0 0 20 20" aria-hidden="true">
  <path
    d="M10.36197.32698A4 4 0 0 1 11.67302 1.63803c.2394.46984.25416.75823.4174 1.06004a4 4 0 0 0 1.21135 1.2114c.30177.16324.59023.17804 1.0602.41751A4 4 0 0 1 15.67302 5.63803C16 6.27976 16 7.11984 16 8.8v2.4c0 1.68016 0 2.52024-.32698 3.16197a4 4 0 0 1-1.31105 1.31105C13.72024 16 12.88016 16 11.2 16H8.8c-1.68016 0-2.52024 0-3.16197-.32698a4 4 0 0 1-1.31105-1.31105c-.23941-.46987-.25415-.75828-.41748-1.06022a4 4 0 0 0-1.2114-1.2113c-.30182-.16326-.59021-.17803-1.06007-.41743A4 4 0 0 1 .32698 10.36197C0 9.72024 0 8.88016 0 7.2V4.8c0-1.68016 0-2.52024.32698-3.16197A4 4 0 0 1 1.63803.32698C2.27976 0 3.11984 0 4.8 0h2.4C8.88016 0 9.72024 0 10.36197.32698Z"
    transform="translate(2 2)"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-miterlimit="10"
    fill-rule="evenodd"
  />
  <path
    d="M4.8 0h2.4C8.88016 0 9.72024 0 10.36197.32698A4 4 0 0 1 11.67302 1.63803C12 2.27976 12 3.11984 12 4.8v2.4c0 1.68016 0 2.52024-.32698 3.16197a4 4 0 0 1-1.31105 1.31105C9.72024 12 8.88016 12 7.2 12H4.8c-1.68016 0-2.52024 0-3.16197-.32698A4 4 0 0 1 .32698 10.36197C0 9.72024 0 8.88016 0 7.2V4.8c0-1.68016 0-2.52024.32698-3.16197A4 4 0 0 1 1.63803.32698C2.27976 0 3.11984 0 4.8 0Z"
    transform="translate(2 2)"
    fill="none"
    stroke="currentColor"
    stroke-width="1.3"
    fill-rule="evenodd"
  />
  <path
    d="M4.8 0h2.4C8.88016 0 9.72024 0 10.36197.32698A4 4 0 0 1 11.67302 1.63803C12 2.27976 12 3.11984 12 4.8v2.4c0 1.68016 0 2.52024-.32698 3.16197a4 4 0 0 1-1.31105 1.31105C9.72024 12 8.88016 12 7.2 12H4.8c-1.68016 0-2.52024 0-3.16197-.32698A4 4 0 0 1 .32698 10.36197C0 9.72024 0 8.88016 0 7.2V4.8c0-1.68016 0-2.52024.32698-3.16197A4 4 0 0 1 1.63803.32698C2.27976 0 3.11984 0 4.8 0Z"
    transform="translate(6 6)"
    fill="none"
    stroke="currentColor"
    stroke-width="1.3"
    fill-rule="evenodd"
  />
  <circle cx="10" cy="10" r="2" fill="currentColor" />
</svg>`;

export const DEVTOOLS_RULERS_ICON = `
<svg viewBox="0 0 20 20" aria-hidden="true">
  <path
    d="M5 3v9.4c0 .56005 0 .84008-.109 1.05399a2 2 0 0 1-.43702.56201 2 2 0 0 1-.56202.437c-.21391.109-.49394.109-1.05398.109H3c-.93188 0-1.39782 0-1.76537-.15224a3 3 0 0 1-1.01664-.93978C0 13.14553 0 12.58547 0 11.46537V3.2c0-1.1201 0-1.68016.21799-2.10798A3 3 0 0 1 1.09202.21799C1.51984 0 2.0799 0 3.2 0h7.6c1.1201 0 1.68016 0 2.10798.21799a3 3 0 0 1 .93978 1.01664C14 1.60218 14 2.06812 14 3v.4c0 .56005 0 .84008-.109 1.05399a2 2 0 0 1-.43701.56202c-.21392.109-.49395.109-1.05399.109H7"
    transform="translate(3 3)"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-miterlimit="10"
    fill-rule="evenodd"
  />
  <path d="M2 0.5H0" transform="translate(6 7.5)" fill="none" stroke="currentColor" stroke-width="1" />
  <path d="M2 0.5H0" transform="translate(6 12.5)" fill="none" stroke="currentColor" stroke-width="1" />
  <path d="M0.5 2V0" transform="translate(12.5 6)" fill="none" stroke="currentColor" stroke-width="1" />
</svg>`;

export const DEVTOOLS_OFFSETS_ICON = `
<svg viewBox="0 0 20 20" aria-hidden="true">
  <path d="M4 7.5H16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
  <path d="M4 12.5H16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
  <path d="M10 2.5V17.5" fill="none" stroke="currentColor" stroke-width="1" stroke-dasharray="1.4 1.4" />
  <path d="M7.5 4.5L10 2L12.5 4.5" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M7.5 15.5L10 18L12.5 15.5" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
</svg>`;

export const DEVTOOLS_OFFSETS_BADGE_ICON = `
<svg viewBox="0 0 16 16" aria-hidden="true">
  <path d="M5 3.5H11" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
  <path d="M5 12.5H11" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
  <path d="M8 1.5V14.5" fill="none" stroke="currentColor" stroke-width="1" stroke-dasharray="1.2 1.2" />
  <path d="M6.2 5.2L8 3.4L9.8 5.2" fill="none" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M6.2 10.8L8 12.6L9.8 10.8" fill="none" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round" />
</svg>`;

export const DEVTOOLS_PROGRESS_ICON = `
<svg viewBox="0 0 20 20" aria-hidden="true">
  <path
    d="M6.4 0h3.2c2.24021 0 3.36031 0 4.21596.43597a4 4 0 0 1 1.74806 1.74807C16 3.03969 16 4.15979 16 6.4v3.2c0 2.24021 0 3.36031-.43598 4.21596a4 4 0 0 1-1.74806 1.74806C12.96031 16 11.84021 16 9.6 16H6.4c-2.24021 0-3.36031 0-4.21596-.43598a4 4 0 0 1-1.74807-1.74806C0 12.96031 0 11.84021 0 9.6V6.4c0-2.24021 0-3.36031.43597-4.21596A4 4 0 0 1 2.18404.43597C3.03969 0 4.15979 0 6.4 0Z"
    transform="translate(2 2)"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-miterlimit="10"
    fill-rule="evenodd"
  />
  <path
    d="M0 6.5L2.9 4.2L5.3 5.8L8.6 2.1"
    transform="translate(5.6 7)"
    fill="none"
    stroke="currentColor"
    stroke-width="1.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M0 0.5H9.5"
    transform="translate(5.25 13.25)"
    fill="none"
    stroke="currentColor"
    stroke-width="1.1"
    stroke-linecap="round"
  />
</svg>`;

export const DEVTOOLS_CHEVRON_ICON = `
<svg viewBox="0 0 12 12" aria-hidden="true">
  <path
    d="M2.25 7.5L6 4.25L9.75 7.5"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;
